import { LodashHelper } from '.';

import { differenceInHours, parseISO, isBefore, addHours } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { RIDE_STATUSES } from '../constants/constants';

export class RideHelper {
  static compareRideValues(defaultValues, exitingValues) {
    const cleanFormikValues = exitingValues && LodashHelper.removeEmpty(exitingValues);
    delete cleanFormikValues?.step1?.formattedRiderName;
    return LodashHelper.isEqual(cleanFormikValues, defaultValues);
  }

  static validateSameDayRoundTrip = (ride) => {

 
    if (!ride?.connectedLeg) {
      return {
        isSameDayRoundTrip: false,
        isLegACompleted: null,
        legA: null,
        legB: null,
      };
    }

    const legA = ride.leg === "A" ? ride : ride.connectedLeg;
    const legB = ride.leg === "B" ? ride : ride.connectedLeg;

    if (!legA.pickUpDate || !legB.pickUpDate) {
      return {
        isSameDayRoundTrip: false,
        isLegACompleted: null,
        legA: null,
        legB: null,
      };
    }

    // Parse pickUpDate to ensure they are valid date objects
    const pickUpDateA = parseISO(legA.pickUpDate.datetime);
    const pickUpDateB = parseISO(legB.pickUpDate.datetime);
   
    // Calculate the difference in hours between the two pickup dates
    const hoursDifference = Math.abs(differenceInHours(pickUpDateA, pickUpDateB));

    // Check if the difference is within 24 hours
    const isSameDayRoundTrip = hoursDifference <= 24;

    // Check if LegA has a status of COMPLETED
    const isLegACompleted = legA.status === "COMPLETED";

    // Return the validation result and the leg objects
    return {
      isSameDayRoundTrip,
      isLegACompleted,
      legA,
      legB,
    };
  }

  static isRideValidForReschedule(ride) {
    if (!ride) {
      return false; // If ride is null or undefined, return false
    }

    if (ride.status !== RIDE_STATUSES.ACCEPTED) {
      return false; // If ride status is not ACCEPTED, return false
    }

     
    if (ride.rescheduledFrom) {
      return false;
    }

    const pickUpDate = utcToZonedTime(parseISO(ride.actualPickUpDate.datetime), ride.actualPickUpDate.timezone); // Convert pickUpDate to the ride's timezone


    if (isNaN(pickUpDate)) {
      return false; // If pickUpDate is invalid, return false
    }


    // Get the current time in the ride's timezone
    const currentTimeInTimezone = utcToZonedTime(new Date(), ride.timezone);

    // Add 48 hours to the current time
    const timeLimit = addHours(currentTimeInTimezone, 48);

    // Log values for debugging


    // Check if the pickUpDate is before the 48-hour limit
    if (isBefore(pickUpDate, timeLimit)) {
      return false;
    }

    // If all checks pass, return true
    return true;
  }
}
